// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1zMJK","content":"styles_content__3NPpk"};